import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialState = {
    kitproduct: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getKitProduct = createAsyncThunk(
    'kitproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllKitProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.kitProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addKitProduct = createAsyncThunk(
    'kitproduct/add',
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createKitProduct', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getKitProduct());
            return response.data.kitProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteKitProduct = createAsyncThunk(
    'kitproduct/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteKitProduct/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteKitDetails = createAsyncThunk(
    'kitproduct/deleteDetails',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deteleKitDetails/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.kitProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const viewKitProduct = createAsyncThunk(
    'kitproduct/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getKitProductById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.kitProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const editKitProduct = createAsyncThunk(
    'kitproduct/edit',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { _id, navigate, ...rest } = data;
            const response = await axiosInstance.put(`${BASE_URL}/updateKitProduct/${_id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getKitProduct());
            return response.data.kitProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getKitcategory = createAsyncThunk(
    'getKitcategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListCategoryInKitProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getKitsubcategory = createAsyncThunk(
    'getKitsubcategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListSubCategoryInKitProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getKitProductData = createAsyncThunk(
    'getKitProduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListProductInKitProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const kitproductSlice = createSlice({
    name: 'kitproduct',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getKitProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching kitproduct...';
            })
            .addCase(getKitProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'KitProduct fetched successfully';
                state.kitproduct = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getKitProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch kitproduct';
            })
            // Add Vendor
            .addCase(addKitProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Adding kitproduct...';
            })
            .addCase(addKitProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.kitproduct.push(action.payload);
                state.message = action.payload?.message || 'KitProduct added successfully';
            })
            .addCase(addKitProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add kitproduct';
            })
            // Delete KitProduct
            .addCase(deleteKitProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting kitproduct...';
            })
            .addCase(deleteKitProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.kitproduct = state.kitproduct.filter((kit) => kit._id !== action.payload);
                state.message = action.payload?.message || 'KitProduct deleted successfully';
            })
            .addCase(deleteKitProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete kitproduct';
            })

            // Delete KitDetails
            .addCase(deleteKitDetails.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting kitdetails...';
            })
            .addCase(deleteKitDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'KitDetails deleted successfully';
            })
            .addCase(deleteKitDetails.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete kitdetails';
            })
            // Edit KitProduct
            .addCase(editKitProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Editing kitproduct...';
            })
            .addCase(editKitProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.kitproduct = state.kitproduct.map((kit) =>
                    kit._id === action.payload._id ? action.payload : kit
                );
                state.message = action.payload?.message || 'KitProduct updated successfully';
            })
            .addCase(editKitProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update kitproduct';
            })
            // get kit category
            .addCase(getKitcategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching kitproduct...';
            })
            .addCase(getKitcategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'KitProduct fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getKitcategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch kitproduct';
            })
            // get kit subCategory
            .addCase(getKitsubcategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching kitproduct...';
            })
            .addCase(getKitsubcategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'KitProduct fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getKitsubcategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch kitproduct';
            })
            // get kit subCategory
            .addCase(getKitProductData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching kitproduct...';
            })
            .addCase(getKitProductData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'KitProduct fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getKitProductData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch kitproduct';
            })
    },
});

export default kitproductSlice.reducer;
